import { Component } from '@angular/core';
import { MainLayout } from '../../../layouts/main-layout';
import { ContactFormComponent } from '../../../components/contacto/contact-form/contact-form';
import { ContactHeaderComponent } from '../../../components/shared/contact-header/contact-header';
import { AllasContactFooterComponent } from '../../../components/shared/ui/allas-contact-footer/allas-contact-footer';
import { Router } from '@angular/router';
import {
  basicFormFields,
  ContactFormControl,
} from '../../../types/Contact.types';
import { MarginWrapper } from '../../../layouts/margin-wrapper';

@Component({
  selector: 'allas-preguntas-pedidos',
  imports: [
    MainLayout,
    MarginWrapper,
    ContactFormComponent,
    ContactHeaderComponent,
    AllasContactFooterComponent,
  ],
  template: `
    <allas-main-layout [showPopularSections]="true" [showNewsletter]="true">
      <allas-margin-wrapper styleClass="py-8">
        <!-- Botón Volver - Completamente a la izquierda -->
        <div class="px-6 py-1 sm:px-8">
          <button
            (click)="goBack()"
            class="flex items-center text-gray-600 hover:text-allasRed transition-colors mb-6"
          >
            <svg
              class="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              ></path>
            </svg>
            VOLVER
          </button>
        </div>

        <section class="mx-auto mb-12 max-w-[80rem] px-6 sm:px-8">
          <!-- Header -->
          <allas-contact-header
            title="PREGUNTAS SOBRE PEDIDOS"
            subtitle="¿Tienes preguntas sobre tu pedido? Podemos ayudarte con eso. Completa el formulario a continuación para que podamos contactarte. Por favor, ten cuidado de no incluir detalles de información personal."
          ></allas-contact-header>

          <!-- Contact Form -->
          <div class="rounded-lg p-2">
            <allas-contact-form
              category="preguntas-pedidos"
              [form]="form"
              (formSubmit)="onFormSubmit($event)"
              (formCancel)="goBack()"
            ></allas-contact-form>
          </div>

          <!-- Contact Footer -->
          <allas-contact-footer></allas-contact-footer>
        </section>
      </allas-margin-wrapper>
    </allas-main-layout>
  `,
})
export class PreguntasPedidos {
  form = basicFormFields;

  constructor(private router: Router) {
    this.form = {
      ...this.form,
      departamento: {
        id: 'departamento',
        label: 'Departamento',
        placeholder: 'Departamento',
        value: '',
        dirty: false,
      },
      numeroDePedido: {
        id: 'numeroDePedido',
        label: 'Número de Pedido',
        placeholder: 'Número de Pedido',
        value: '',
        dirty: false,
      },
      ciudad: {
        id: 'ciudad',
        label: 'Ciudad',
        placeholder: 'Ciudad',
        value: '',
        dirty: false,
      },
      numeroDeFactura: {
        id: 'numeroDeFactura',
        label: 'Número de Factura',
        placeholder: 'Número de Factura',
        value: '',
        dirty: false,
      },
      comentarios: {
        id: 'comentarios',
        label: 'Comentarios',
        placeholder: 'Describe tu consulta o comentario aquí...',
        value: '',
        dirty: false,
        type: 'textarea',
        fullWidth: true,
      },
    };
  }

  goBack() {
    this.router.navigate(['/contactanos']);
  }

  onFormSubmit(formData: ContactFormControl) {
    console.log(formData);
    this.goBack();
  }
}
